import { Reducer } from "redux";

import MarketingConsentsState from "./MarketingConsentsState";
import { MarketingConsentsActionTypes, MarketingConsentsAction } from "./MarketingConsentsActions";

const initialState: MarketingConsentsState = {
  isClosedDialog: false
};

const MarketingConsentsReducer: Reducer<MarketingConsentsState, MarketingConsentsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case MarketingConsentsActionTypes.SET_CLOSED_DIALOG: {
      return {
        ...state,
        ...{
          isClosedDialog: action.data
        }
      };
    }
    default: {
      return state;
    }
  }
};

export default MarketingConsentsReducer;